<template>
  <span class="ii-logo">
    <img src="/ininvoice-mark.svg" alt="" class="ii-logo__mark" aria-hidden="true" />
    <span class="ii-logo__text">ininvoice</span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'BrandLogo' });
</script>

<style>
/* El logo de ininvoice es el de la cabecera de la web (landing/js/nav.js, buildLogo):
   la marca `/ininvoice-mark.svg` y la palabra «ininvoice», con los mismos valores.
   Este fichero es el mismo, byte a byte, en frontend/ y en auth-frontend/
   (src/components/brand/BrandLogo.vue): `logoIsTheSameEverywhere.spec.ts` lo comprueba.
   El `!important` de la familia gana al `* { font-family … !important }` de app.scss. */
.ii-logo {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.ii-logo__mark {
  height: 13px;
  width: auto;
  display: block;
}

.ii-logo__text {
  font-family: 'Google Sans', system-ui, sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.005em;
  line-height: 1;
  color: #0A2540;
}
</style>
